import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchMemberships = createAsyncThunk(
  "memberships/fetchMemberships",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        "https://b2i4nr8bza.execute-api.ap-south-1.amazonaws.com/Prod/Membership/GetAllMemberships"
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "API Error");
    }
  }
);

const membershipSlice = createSlice({
  name: "memberships",
  initialState: {
    loading: false,
    plans: [],
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMemberships.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMemberships.fulfilled, (state, action) => {
        state.loading = false;
        state.plans = action.payload;
      })
      .addCase(fetchMemberships.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default membershipSlice.reducer;
